export default __webpack_public_path__ + "static/media/base_station.9148b981.svg";